import Footer from "components/footer/FooterAuthDefault";
import AuthPortalHero from "components/auth/AuthPortalHero";
import AuthPortalIntro from "components/auth/AuthPortalIntro";
import { Link, Routes, Route, Navigate, useLocation } from "react-router-dom";
import routes from "routes";
import { applyLanguage, getStoredLanguage } from "lib/language";
import { useAppLanguage } from "hooks/useAppLanguage";
import { authStorage } from "services/authStorage";
import { useEffect } from "react";
import type { AuthPortal } from "lib/authPortalCopy";

function portalFromPath(pathname: string): AuthPortal {
  return pathname.includes("instructor-sign-in") ? "instructor" : "admin";
}

export default function Auth() {
  const location = useLocation();
  const language = useAppLanguage();
  const portal = portalFromPath(location.pathname);

  useEffect(() => {
    applyLanguage(getStoredLanguage());
  }, []);

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return <Route path={prop.path} element={prop.component} key={key} />;
      }
      return null;
    });
  };

  const backHref = authStorage.isAuthenticated(portal === "admin" ? "admin" : "instructor")
    ? authStorage.dashboardPath(portal === "admin" ? "admin" : "instructor")
    : null;

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#07111d] text-white dark:bg-[#07111d]">
      <AuthPortalHero portal={portal} backgroundOnly key={portal} />
      <div className="pointer-events-none absolute inset-0 bg-[#07111d]/55" />
      <main className="relative z-10 mx-auto flex min-h-screen w-full items-center justify-center px-4 py-10 sm:px-8">
        <div className="pointer-events-none absolute inset-0">
          <div
            className={`absolute -top-32 h-96 w-96 rounded-full blur-3xl ${
              portal === "admin" ? "-left-24 bg-brand-500/10" : "-right-24 bg-teal-500/10"
            }`}
          />
          <div className="absolute -bottom-40 -left-32 h-[520px] w-[520px] rounded-full bg-indigo-500/5 blur-3xl" />
        </div>

        <div className="relative flex w-full max-w-[720px] flex-col items-center">
          <AuthPortalIntro portal={portal} />
          <div className="w-full pb-20">
              {backHref ? (
                <div className="mb-5 flex justify-end">
                  <Link
                    to={backHref}
                    className="text-sm font-semibold text-white/60 transition hover:text-white"
                  >
                    {language === "ar" ? "العودة للوحة التحكم" : "Back to dashboard"}
                  </Link>
                </div>
              ) : null}

              <div className="flex items-center justify-center">
                <div className="w-full">
                  <Routes>
                    {getRoutes(routes)}
                    <Route index element={<Navigate to="instructor-sign-in" replace />} />
                  </Routes>
                </div>
              </div>

              <div className="absolute bottom-3 left-0 right-0">
                <Footer />
              </div>
            </div>
          </div>
      </main>
    </div>
  );
}
